/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ credits: NonNullable<unknown> }} Check_In_EarnedInputs */

const en_check_in_earned = /** @type {(inputs: Check_In_EarnedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Earned ${i?.credits} check-in credits`)
};

const es_check_in_earned = /** @type {(inputs: Check_In_EarnedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.credits} creditos de registro obtenidos`)
};

/**
* | output |
* | --- |
* | "Earned {credits} check-in credits" |
*
* @param {Check_In_EarnedInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const check_in_earned = /** @type {((inputs: Check_In_EarnedInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Check_In_EarnedInputs, { locale?: "en" | "es" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_check_in_earned(inputs)
	return es_check_in_earned(inputs)
});